// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegistracePodnikuRouteImport } from './routes/registrace-podniku'
import { Route as ProfilRouteImport } from './routes/profil'
import { Route as PokrytiKataloguRouteImport } from './routes/pokryti-katalogu'
import { Route as NotifikaceRouteImport } from './routes/notifikace'
import { Route as MapaVerejnaRouteImport } from './routes/mapa-verejna'
import { Route as MapaRouteImport } from './routes/mapa'
import { Route as MajiteleVacantuRouteImport } from './routes/majitele-vacantu'
import { Route as KeStazeniRouteImport } from './routes/ke-stazeni'
import { Route as DoporucitelRouteImport } from './routes/doporucitel'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MojePodnikyIndexRouteImport } from './routes/moje-podniky.index'
import { Route as UzivatelUserIdRouteImport } from './routes/uzivatel.$userId'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as QaMapaPrekladyRouteImport } from './routes/qa.mapa-preklady'
import { Route as ProvozovnaIdRouteImport } from './routes/provozovna.$id'
import { Route as PlatbaZrusenoRouteImport } from './routes/platba.zruseno'
import { Route as PlatbaUspechRouteImport } from './routes/platba.uspech'
import { Route as DevA11yStatesRouteImport } from './routes/dev.a11y-states'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminVyplatyRouteImport } from './routes/admin.vyplaty'
import { Route as AdminVacantyRouteImport } from './routes/admin.vacanty'
import { Route as AdminVacantFunkceRouteImport } from './routes/admin.vacant-funkce'
import { Route as AdminUzivateleRouteImport } from './routes/admin.uzivatele'
import { Route as AdminTestUcetRouteImport } from './routes/admin.test-ucet'
import { Route as AdminSchemataRoleRouteImport } from './routes/admin.schemata-role'
import { Route as AdminSchemataRouteImport } from './routes/admin.schemata'
import { Route as AdminRlsAuditRouteImport } from './routes/admin.rls-audit'
import { Route as AdminResendPokusyRouteImport } from './routes/admin.resend-pokusy'
import { Route as AdminReportyRouteImport } from './routes/admin.reporty'
import { Route as AdminRecenzeReportyRouteImport } from './routes/admin.recenze-reporty'
import { Route as AdminRecenzeRouteImport } from './routes/admin.recenze'
import { Route as AdminPrekladyCenikRouteImport } from './routes/admin.preklady-cenik'
import { Route as AdminPredplatnaRouteImport } from './routes/admin.predplatna'
import { Route as AdminPozvankyRouteImport } from './routes/admin.pozvanky'
import { Route as AdminPodnikyRouteImport } from './routes/admin.podniky'
import { Route as AdminPaymentFailedRouteImport } from './routes/admin.payment-failed'
import { Route as AdminOverovaniAdresRouteImport } from './routes/admin.overovani-adres'
import { Route as AdminOdkazyRouteImport } from './routes/admin.odkazy'
import { Route as AdminMcpAuditRouteImport } from './routes/admin.mcp-audit'
import { Route as AdminMapaAuditRouteImport } from './routes/admin.mapa-audit'
import { Route as AdminManualyEmailyRouteImport } from './routes/admin.manualy-emaily'
import { Route as AdminManualyRouteImport } from './routes/admin.manualy'
import { Route as AdminMajiteleVacantuRouteImport } from './routes/admin.majitele-vacantu'
import { Route as AdminKatalogImportRouteImport } from './routes/admin.katalog-import'
import { Route as AdminJazykyRouteImport } from './routes/admin.jazyky'
import { Route as AdminImportDcRouteImport } from './routes/admin.import-dc'
import { Route as AdminDoporuceniRouteImport } from './routes/admin.doporuceni'
import { Route as AdminCenikRouteImport } from './routes/admin.cenik'
import { Route as PodnikIdIndexRouteImport } from './routes/podnik.$id.index'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as MojePodnikyIdMenuIndexRouteImport } from './routes/moje-podniky.$id.menu.index'
import { Route as PodnikIdMenuMenuSlugRouteImport } from './routes/podnik.$id.menu.$menuSlug'
import { Route as PodnikIdDodavatelSupplierIdRouteImport } from './routes/podnik.$id.dodavatel.$supplierId'
import { Route as MojePodnikyIdMenuMenuIdRouteImport } from './routes/moje-podniky.$id.menu.$menuId'

const RegistracePodnikuRoute = RegistracePodnikuRouteImport.update({
            id: '/registrace-podniku',path: '/registrace-podniku',getParentRoute: () => rootRouteImport
          })
const ProfilRoute = ProfilRouteImport.update({
            id: '/profil',path: '/profil',getParentRoute: () => rootRouteImport
          })
const PokrytiKataloguRoute = PokrytiKataloguRouteImport.update({
            id: '/pokryti-katalogu',path: '/pokryti-katalogu',getParentRoute: () => rootRouteImport
          })
const NotifikaceRoute = NotifikaceRouteImport.update({
            id: '/notifikace',path: '/notifikace',getParentRoute: () => rootRouteImport
          })
const MapaVerejnaRoute = MapaVerejnaRouteImport.update({
            id: '/mapa-verejna',path: '/mapa-verejna',getParentRoute: () => rootRouteImport
          })
const MapaRoute = MapaRouteImport.update({
            id: '/mapa',path: '/mapa',getParentRoute: () => rootRouteImport
          })
const MajiteleVacantuRoute = MajiteleVacantuRouteImport.update({
            id: '/majitele-vacantu',path: '/majitele-vacantu',getParentRoute: () => rootRouteImport
          })
const KeStazeniRoute = KeStazeniRouteImport.update({
            id: '/ke-stazeni',path: '/ke-stazeni',getParentRoute: () => rootRouteImport
          })
const DoporucitelRoute = DoporucitelRouteImport.update({
            id: '/doporucitel',path: '/doporucitel',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const MojePodnikyIndexRoute = MojePodnikyIndexRouteImport.update({
            id: '/moje-podniky/',path: '/moje-podniky/',getParentRoute: () => rootRouteImport
          })
const UzivatelUserIdRoute = UzivatelUserIdRouteImport.update({
            id: '/uzivatel/$userId',path: '/uzivatel/$userId',getParentRoute: () => rootRouteImport
          })
const RCodeRoute = RCodeRouteImport.update({
            id: '/r/$code',path: '/r/$code',getParentRoute: () => rootRouteImport
          })
const QaMapaPrekladyRoute = QaMapaPrekladyRouteImport.update({
            id: '/qa/mapa-preklady',path: '/qa/mapa-preklady',getParentRoute: () => rootRouteImport
          })
const ProvozovnaIdRoute = ProvozovnaIdRouteImport.update({
            id: '/provozovna/$id',path: '/provozovna/$id',getParentRoute: () => rootRouteImport
          })
const PlatbaZrusenoRoute = PlatbaZrusenoRouteImport.update({
            id: '/platba/zruseno',path: '/platba/zruseno',getParentRoute: () => rootRouteImport
          })
const PlatbaUspechRoute = PlatbaUspechRouteImport.update({
            id: '/platba/uspech',path: '/platba/uspech',getParentRoute: () => rootRouteImport
          })
const DevA11yStatesRoute = DevA11yStatesRouteImport.update({
            id: '/dev/a11y-states',path: '/dev/a11y-states',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminVyplatyRoute = AdminVyplatyRouteImport.update({
            id: '/vyplaty',path: '/vyplaty',getParentRoute: () => AdminRoute
          })
const AdminVacantyRoute = AdminVacantyRouteImport.update({
            id: '/vacanty',path: '/vacanty',getParentRoute: () => AdminRoute
          })
const AdminVacantFunkceRoute = AdminVacantFunkceRouteImport.update({
            id: '/vacant-funkce',path: '/vacant-funkce',getParentRoute: () => AdminRoute
          })
const AdminUzivateleRoute = AdminUzivateleRouteImport.update({
            id: '/uzivatele',path: '/uzivatele',getParentRoute: () => AdminRoute
          })
const AdminTestUcetRoute = AdminTestUcetRouteImport.update({
            id: '/test-ucet',path: '/test-ucet',getParentRoute: () => AdminRoute
          })
const AdminSchemataRoleRoute = AdminSchemataRoleRouteImport.update({
            id: '/schemata-role',path: '/schemata-role',getParentRoute: () => AdminRoute
          })
const AdminSchemataRoute = AdminSchemataRouteImport.update({
            id: '/schemata',path: '/schemata',getParentRoute: () => AdminRoute
          })
const AdminRlsAuditRoute = AdminRlsAuditRouteImport.update({
            id: '/rls-audit',path: '/rls-audit',getParentRoute: () => AdminRoute
          })
const AdminResendPokusyRoute = AdminResendPokusyRouteImport.update({
            id: '/resend-pokusy',path: '/resend-pokusy',getParentRoute: () => AdminRoute
          })
const AdminReportyRoute = AdminReportyRouteImport.update({
            id: '/reporty',path: '/reporty',getParentRoute: () => AdminRoute
          })
const AdminRecenzeReportyRoute = AdminRecenzeReportyRouteImport.update({
            id: '/recenze-reporty',path: '/recenze-reporty',getParentRoute: () => AdminRoute
          })
const AdminRecenzeRoute = AdminRecenzeRouteImport.update({
            id: '/recenze',path: '/recenze',getParentRoute: () => AdminRoute
          })
const AdminPrekladyCenikRoute = AdminPrekladyCenikRouteImport.update({
            id: '/preklady-cenik',path: '/preklady-cenik',getParentRoute: () => AdminRoute
          })
const AdminPredplatnaRoute = AdminPredplatnaRouteImport.update({
            id: '/predplatna',path: '/predplatna',getParentRoute: () => AdminRoute
          })
const AdminPozvankyRoute = AdminPozvankyRouteImport.update({
            id: '/pozvanky',path: '/pozvanky',getParentRoute: () => AdminRoute
          })
const AdminPodnikyRoute = AdminPodnikyRouteImport.update({
            id: '/podniky',path: '/podniky',getParentRoute: () => AdminRoute
          })
const AdminPaymentFailedRoute = AdminPaymentFailedRouteImport.update({
            id: '/payment-failed',path: '/payment-failed',getParentRoute: () => AdminRoute
          })
const AdminOverovaniAdresRoute = AdminOverovaniAdresRouteImport.update({
            id: '/overovani-adres',path: '/overovani-adres',getParentRoute: () => AdminRoute
          })
const AdminOdkazyRoute = AdminOdkazyRouteImport.update({
            id: '/odkazy',path: '/odkazy',getParentRoute: () => AdminRoute
          })
const AdminMcpAuditRoute = AdminMcpAuditRouteImport.update({
            id: '/mcp-audit',path: '/mcp-audit',getParentRoute: () => AdminRoute
          })
const AdminMapaAuditRoute = AdminMapaAuditRouteImport.update({
            id: '/mapa-audit',path: '/mapa-audit',getParentRoute: () => AdminRoute
          })
const AdminManualyEmailyRoute = AdminManualyEmailyRouteImport.update({
            id: '/manualy-emaily',path: '/manualy-emaily',getParentRoute: () => AdminRoute
          })
const AdminManualyRoute = AdminManualyRouteImport.update({
            id: '/manualy',path: '/manualy',getParentRoute: () => AdminRoute
          })
const AdminMajiteleVacantuRoute = AdminMajiteleVacantuRouteImport.update({
            id: '/majitele-vacantu',path: '/majitele-vacantu',getParentRoute: () => AdminRoute
          })
const AdminKatalogImportRoute = AdminKatalogImportRouteImport.update({
            id: '/katalog-import',path: '/katalog-import',getParentRoute: () => AdminRoute
          })
const AdminJazykyRoute = AdminJazykyRouteImport.update({
            id: '/jazyky',path: '/jazyky',getParentRoute: () => AdminRoute
          })
const AdminImportDcRoute = AdminImportDcRouteImport.update({
            id: '/import-dc',path: '/import-dc',getParentRoute: () => AdminRoute
          })
const AdminDoporuceniRoute = AdminDoporuceniRouteImport.update({
            id: '/doporuceni',path: '/doporuceni',getParentRoute: () => AdminRoute
          })
const AdminCenikRoute = AdminCenikRouteImport.update({
            id: '/cenik',path: '/cenik',getParentRoute: () => AdminRoute
          })
const PodnikIdIndexRoute = PodnikIdIndexRouteImport.update({
            id: '/podnik/$id/',path: '/podnik/$id/',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const MojePodnikyIdMenuIndexRoute = MojePodnikyIdMenuIndexRouteImport.update({
            id: '/moje-podniky/$id/menu/',path: '/moje-podniky/$id/menu/',getParentRoute: () => rootRouteImport
          })
const PodnikIdMenuMenuSlugRoute = PodnikIdMenuMenuSlugRouteImport.update({
            id: '/podnik/$id/menu/$menuSlug',path: '/podnik/$id/menu/$menuSlug',getParentRoute: () => rootRouteImport
          })
const PodnikIdDodavatelSupplierIdRoute = PodnikIdDodavatelSupplierIdRouteImport.update({
            id: '/podnik/$id/dodavatel/$supplierId',path: '/podnik/$id/dodavatel/$supplierId',getParentRoute: () => rootRouteImport
          })
const MojePodnikyIdMenuMenuIdRoute = MojePodnikyIdMenuMenuIdRouteImport.update({
            id: '/moje-podniky/$id/menu/$menuId',path: '/moje-podniky/$id/menu/$menuId',getParentRoute: () => rootRouteImport
          })





const AdminRouteChildren = {
  AdminCenikRoute: AdminCenikRoute,AdminDoporuceniRoute: AdminDoporuceniRoute,AdminImportDcRoute: AdminImportDcRoute,AdminJazykyRoute: AdminJazykyRoute,AdminKatalogImportRoute: AdminKatalogImportRoute,AdminMajiteleVacantuRoute: AdminMajiteleVacantuRoute,AdminManualyRoute: AdminManualyRoute,AdminManualyEmailyRoute: AdminManualyEmailyRoute,AdminMapaAuditRoute: AdminMapaAuditRoute,AdminMcpAuditRoute: AdminMcpAuditRoute,AdminOdkazyRoute: AdminOdkazyRoute,AdminOverovaniAdresRoute: AdminOverovaniAdresRoute,AdminPaymentFailedRoute: AdminPaymentFailedRoute,AdminPodnikyRoute: AdminPodnikyRoute,AdminPozvankyRoute: AdminPozvankyRoute,AdminPredplatnaRoute: AdminPredplatnaRoute,AdminPrekladyCenikRoute: AdminPrekladyCenikRoute,AdminRecenzeRoute: AdminRecenzeRoute,AdminRecenzeReportyRoute: AdminRecenzeReportyRoute,AdminReportyRoute: AdminReportyRoute,AdminResendPokusyRoute: AdminResendPokusyRoute,AdminRlsAuditRoute: AdminRlsAuditRoute,AdminSchemataRoute: AdminSchemataRoute,AdminSchemataRoleRoute: AdminSchemataRoleRoute,AdminTestUcetRoute: AdminTestUcetRoute,AdminUzivateleRoute: AdminUzivateleRoute,AdminVacantFunkceRoute: AdminVacantFunkceRoute,AdminVacantyRoute: AdminVacantyRoute,AdminVyplatyRoute: AdminVyplatyRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AuthRouteChildren = {
  AuthResetPasswordRoute: AuthResetPasswordRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRouteWithChildren,DoporucitelRoute: DoporucitelRoute,KeStazeniRoute: KeStazeniRoute,MajiteleVacantuRoute: MajiteleVacantuRoute,MapaRoute: MapaRoute,MapaVerejnaRoute: MapaVerejnaRoute,NotifikaceRoute: NotifikaceRoute,PokrytiKataloguRoute: PokrytiKataloguRoute,ProfilRoute: ProfilRoute,RegistracePodnikuRoute: RegistracePodnikuRoute,DevA11yStatesRoute: DevA11yStatesRoute,PlatbaUspechRoute: PlatbaUspechRoute,PlatbaZrusenoRoute: PlatbaZrusenoRoute,ProvozovnaIdRoute: ProvozovnaIdRoute,QaMapaPrekladyRoute: QaMapaPrekladyRoute,RCodeRoute: RCodeRoute,UzivatelUserIdRoute: UzivatelUserIdRoute,MojePodnikyIndexRoute: MojePodnikyIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute,PodnikIdIndexRoute: PodnikIdIndexRoute,MojePodnikyIdMenuMenuIdRoute: MojePodnikyIdMenuMenuIdRoute,PodnikIdDodavatelSupplierIdRoute: PodnikIdDodavatelSupplierIdRoute,PodnikIdMenuMenuSlugRoute: PodnikIdMenuMenuSlugRoute,MojePodnikyIdMenuIndexRoute: MojePodnikyIdMenuIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)